import qs from "qs";
export default {
  // 数据脱敏
  //  * @param str 脱敏字符串
  //  * @param begin 起始保留长度，从0开始
  //  * @param end 结束保留长度，到str.length结束
  //  * @returns {string|*}
  desensitization(str, begin, end) {
    if (!str && begin + end >= str.length) {
      return "";
    }

    let leftStr = str.substring(0, begin);
    let rightStr = str.substring(end);
    let midStr = str.substring(begin, end);
    let strCon = "";
    for (let i = 0; i < midStr.length; i++) {
      strCon += "*";
    }
    return leftStr + strCon + rightStr;
  },

  //post接口 转义数据
  handleParams(params) {
    let _params = qs.stringify(params, {
      arrayFormat: "repeat",
      indices: false,
    });
    return _params;
  },
  // 按照后台要求格式化时间 将 去掉 年份前两位的 2301011200 转换为 2023-01-01 12:00:00
  handleDate(date) {
    if (date) {
      let _data = (date + "").split("");
      let _returnDate = "";
      for (let i in _data) {
        if (i == 2 || i == 4) {
          _returnDate = _returnDate + "-" + _data[i];
        } else if (i == 6) {
          _returnDate = _returnDate + " " + _data[i];
        } else if (i == 8) {
          _returnDate = _returnDate + ":" + _data[i];
        } else {
          _returnDate += _data[i];
        }
      }
      return "20" + _returnDate;
    } else {
      return "--";
    }
  },
  // 按照后台要求格式化时间 将 2023-01-01 12:00:00  转换为去掉 年份前两位的 2301011200
  restore(date) {
    if (date) {
      return date.substring(2).replace(/[- :]/g, "");
    } else {
      console.log("时间数据消失");
    }
  },
  formatDate(date, status) {
    //将时间戳转换成时间格式
    if (date) {
      let ndate = new Date(date);
      let year = ndate.getFullYear();
      let month = ndate.getMonth() + 1;
      let day = ndate.getDate();
      let hours = ndate.getHours(); // 小时
      let minutes = ndate.getMinutes(); // 分钟
      let seconds = ndate.getSeconds(); // 秒数
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      let edate;
      if (status == "m") {
        edate = year + "-" + month;
      } else if (status == "s") {
        edate =
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds;
      } else {
        edate = year + "-" + month + "-" + day;
      }
      return edate;
    }
  },
  //获取url的参数
  getUrlParam(name) {
    var url = decodeURIComponent(window.location.href);
    var reg = new RegExp("(\\?|&)" + name + "=([^&?#]*)", "i");
    var arr = url.match(reg);
    if (arr) {
      return arr[2];
    }
    return null;
  },
  //取cookie
  getCookie(name) {
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    var arr = document.cookie.match(reg);
    if (arr) {
      return arr[2];
    } else {
      return null;
    }
  },
  //存cookie
  setCookie(name, value) {
    var exp = new Date();
    exp.setTime(exp.getTime() + 1 * 60 * 60 * 1000);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  },
  //保存cookie
  //参数：cookie名,cookie值,有效时长(单位：天)
  saveCookie(cookieName, cookieValue, cookieDates) {
    var d = new Date();
    d.setDate(d.getDate() + cookieDates);
    document.cookie =
      cookieName + "=" + cookieValue + ";expires=" + d.toGMTString();
  },
  //dates为数字类型，0代表今日,-1代表昨日，1代表明日，返回yyyy-mm-dd格式字符串，dates不传默认代表今日。
  getDate(dates) {
    var dd = new Date();
    var n = dates || 0;
    dd.setDate(dd.getDate() + n);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;
    var d = dd.getDate();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    var day = y + "-" + m + "-" + d;
    return day;
  },
  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表本周，-1代表上周，1代表下周
  //得到下周一的yyyy-mm-dd格式日期
  //得到下周日的yyyy-mm-dd格式日期
  getMonday(type, dates) {
    var now = new Date();
    var nowTime = now.getTime();
    var day = now.getDay();
    var longTime = 24 * 60 * 60 * 1000;
    var n = longTime * 7 * (dates || 0);
    if (type == "s") {
      var dd = nowTime - (day - 1) * longTime + n;
    }
    if (type == "e") {
      var dd = nowTime + (7 - day) * longTime + n;
    }
    dd = new Date(dd);
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;
    var d = dd.getDate();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    var day = y + "-" + m + "-" + d;
    return day;
  },
  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，months为数字类型，不传或0代表本月，-1代表上月，1代表下月
  //得到下月第一天的yyyy-mm-dd格式日期
  //得到下月最后一天的yyyy-mm-dd格式日期
  getMonth(type, months) {
    var d = new Date();
    var year = d.getFullYear();
    var month = d.getMonth() + 1;
    if (Math.abs(months) > 12) {
      months = months % 12;
    }
    if (months != 0) {
      if (month + months > 12) {
        year++;
        month = (month + months) % 12;
      } else if (month + months < 1) {
        year--;
        month = 12 + month + months;
      } else {
        month = month + months;
      }
    }
    month = month < 10 ? "0" + month : month;
    var date = d.getDate();
    var firstday = year + "-" + month + "-" + "01";
    var lastday = "";
    if (
      month == "01" ||
      month == "03" ||
      month == "05" ||
      month == "07" ||
      month == "08" ||
      month == "10" ||
      month == "12"
    ) {
      lastday = year + "-" + month + "-" + 31;
    } else if (month == "02") {
      if (
        (year % 4 == 0 && year % 100 != 0) ||
        (year % 100 == 0 && year % 400 == 0)
      ) {
        lastday = year + "-" + month + "-" + 29;
      } else {
        lastday = year + "-" + month + "-" + 28;
      }
    } else {
      lastday = year + "-" + month + "-" + 30;
    }
    var day = "";
    if (type == "s") {
      day = firstday;
    } else {
      day = lastday;
    }
    return day;
  },
  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表今年，-1代表去年，1代表明年
  //得到明年第一天的yyyy-mm-dd格式日期
  //得到明年最后一天的yyyy-mm-dd格式日期
  getYear(type, dates) {
    var dd = new Date();
    var n = dates || 0;
    var year = dd.getFullYear() + Number(n);
    if (type == "s") {
      var day = year + "-01-01";
    }
    if (type == "e") {
      var day = year + "-12-31";
    }
    if (!type) {
      var day = year + "-01-01/" + year + "-12-31";
    }
    return day;
  },
};
